import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { Slot, component$ } from '@builder.io/qwik';
import { getHeaderHeight } from '~/utilities/getHeaderHeight';
import { AppDataContext } from '~/contexts/AppDataContext';
import { ArticleContext } from '~/contexts/ArticleContext';
import { useIsSI } from '~/utilities/useIsSI';
import { SI_HEADER_EXTRA_HEIGHT_PX } from '~/constants/SI_LAYOUT_CONSTANTS';

export default component$((): JSX.Element => {
  const {
    themeComponents,
    payloadToSSR: { layout },
  } = useContext(AppDataContext);
  const isSI = useIsSI();

  const article = useContext(ArticleContext);
  if (!article) return <></>;

  const desktopHeaderHeight = getHeaderHeight(themeComponents, layout, {
    isSI,
    add: isSI ? SI_HEADER_EXTRA_HEIGHT_PX : 0,
  });

  const tabletHeaderHeight = getHeaderHeight(themeComponents, layout, {
    isSI,
    screenSize: 'Medium',
    add: isSI ? SI_HEADER_EXTRA_HEIGHT_PX : 0,
  });

  const mobileHeaderHeight = getHeaderHeight(themeComponents, layout, {
    isSI,
    screenSize: 'Small',
    add: isSI ? SI_HEADER_EXTRA_HEIGHT_PX : 0,
  });

  return (
    <>
      <style>
        {`#body-0 {margin-top: ${desktopHeaderHeight};}
          ${
            desktopHeaderHeight !== tabletHeaderHeight
              ? `@media (max-width: 1079px) {
            #body-0 {margin-top: ${tabletHeaderHeight};}
          }`
              : ''
          }
          ${
            mobileHeaderHeight !== tabletHeaderHeight
              ? `@media (max-width: 719px) {
            #body-0 {margin-top: ${mobileHeaderHeight};}
          }`
              : ''
          }`}
      </style>
      <div id={`body-${article.finiteScrollNumber}`}>
        <Slot />
      </div>
    </>
  );
});
